export function describeType(value: any): Object {
    return { method: [] };        // empty list of methods
}